import React from 'react';
import { motion } from 'framer-motion';

// Animated path component for the hamburger icon
const Path = (props) => (
  <motion.path
    fill="transparent"
    strokeWidth="2.5"
    stroke="currentColor"
    strokeLinecap="round"
    {...props}
  />
);

// Premium floating menu toggle button
export const MenuToggle = ({ toggle, isOpen }) => (
  <motion.button
    onClick={toggle}
    className="
      fixed top-4 left-4 z-50
      w-12 h-12
      flex items-center justify-center
      bg-white/90 backdrop-blur-md
      border border-slate-200/60
      rounded-xl
      shadow-lg shadow-slate-900/5
      cursor-pointer
      pointer-events-auto
      outline-none
      text-slate-700
      transition-colors duration-200
      hover:bg-amber-50 hover:border-amber-200/60 hover:text-amber-700
      focus:ring-2 focus:ring-amber-400/30 focus:ring-offset-2
    "
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    initial={false}
    animate={isOpen ? 'open' : 'closed'}
  >
    <svg width="20" height="20" viewBox="0 0 20 20">
      <Path
        variants={{
          closed: { d: 'M 2 4 L 18 4' },
          open: { d: 'M 4 16 L 16 4' },
        }}
        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      />
      <Path
        d="M 2 10 L 18 10"
        variants={{
          closed: { opacity: 1, x: 0 },
          open: { opacity: 0, x: 10 },
        }}
        transition={{ duration: 0.2 }}
      />
      <Path
        variants={{
          closed: { d: 'M 2 16 L 18 16' },
          open: { d: 'M 4 4 L 16 16' },
        }}
        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      />
    </svg>
  </motion.button>
);

export default MenuToggle;
